import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon, FlagIcon, BookOpenIcon, ActivityIcon, CheckCircleIcon } from 'lucide-react';
export function Hero() {
  const features = [{
    icon: <FileTextIcon className="w-4 h-4" data-id="element-122" />,
    text: '100% PDF'
  }, {
    icon: <ZapIcon className="w-4 h-4" data-id="element-123" />,
    text: 'Acceso en 5 min'
  }, {
    icon: <FlagIcon className="w-4 h-4" data-id="element-124" />,
    text: 'Hecho para Argentina'
  }, {
    icon: <BookOpenIcon className="w-4 h-4" data-id="element-125" />,
    text: '6 Tomos completos'
  }, {
    icon: <ActivityIcon className="w-4 h-4" data-id="element-126" />,
    text: 'Masa → Negocio en pesos'
  }, {
    icon: <CheckCircleIcon className="w-4 h-4" data-id="element-127" />,
    text: '4 Bonos incluidos'
  }];
  const stats = ['+500 emprendedoras confían', '6 Tomos listos', '4 Bonos incluidos', '4,9/5 ⭐'];
  return <section className="w-full bg-[#F7F2EA] bg-texture pt-4 pb-12 md:pt-6 md:pb-20" data-id="element-128">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-130">
          <div className="mb-2" data-id="element-131">
            <span className="inline-block bg-[#F3ECE2] border border-[#E7DDD2] text-[#B66A2C] font-semibold tracking-widest px-4 py-1.5 rounded-full text-xs uppercase" data-id="element-132">
              RECURSOHUB™
            </span>
          </div>

          <div className="max-w-4xl mx-auto" data-id="element-133">
            <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl text-[#3E2B1F] font-bold leading-[1.1] mb-3" data-id="element-134">
              Convertí tu cocina en un negocio de minidonas.
            </h1>

            <h2 className="font-sans text-lg md:text-xl text-[#3E2B1F]/80 leading-relaxed max-w-3xl mx-auto mb-4" data-id="element-135">
              Aprendé a crear minidonas dulces, saladas, tortas y torres
              temáticas para vender en cumpleaños, eventos y redes sociales,
              incluso si empezás desde cero.
            </h2>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2,
          duration: 0.8
        }} className="mt-1 mb-6 relative" data-id="element-136">
            <div className="absolute inset-0 bg-gradient-to-t from-[#F7F2EA] via-transparent to-transparent z-10 h-full w-full pointer-events-none opacity-40" data-id="element-137"></div>
            <img src="https://cdn.magicpatterns.com/uploads/61Qh3FZDLKWfq5RTy8CZuh/ChatGPT_Image_28_jun_2026,_09_58_38_p.m..png" alt="Mega Pack Emprende Minidonas 360 — 6 Tomos + 4 Bonos" className="max-w-2xl lg:max-w-4xl mx-auto w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-138" />
          </motion.div>

          <div className="flex flex-wrap justify-center gap-1.5 mb-5 max-w-4xl mx-auto" data-id="element-139">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4 + index * 0.1,
            duration: 0.4
          }} className="flex items-center gap-1.5 bg-white border border-[#E7DDD2] rounded-full px-2.5 py-1 shadow-sm" data-id="element-140">
                <span className="text-[#B66A2C] [&>svg]:w-3 [&>svg]:h-3" data-id="element-141">
                  {feature.icon}
                </span>
                <span className="text-xs text-[#3E2B1F] font-medium whitespace-nowrap" data-id="element-142">
                  {feature.text}
                </span>
              </motion.div>)}
          </div>

          <motion.a href="https://www.recursohub.com/cart/48199368966336:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block bg-[#C96B17] hover:bg-[#A95712] text-white font-bold text-lg md:text-xl px-10 py-5 rounded-2xl mb-3 transition-all duration-300 shadow-premium hover:shadow-premium-hover" data-id="element-143">
            QUIERO EMPEZAR MI EMPRENDIMIENTO
          </motion.a>

          <p className="text-sm text-[#3E2B1F]/60 mb-6 font-medium" data-id="element-144">
            Acceso inmediato por Mail · 50% OFF Solo por Hoy
          </p>

          <div className="flex flex-wrap justify-center gap-x-2 gap-y-1.5 max-w-3xl mx-auto" data-id="element-145">
            {stats.map((stat, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.8 + index * 0.1,
            duration: 0.4
          }} className="bg-white border border-[#E7DDD2] rounded-full px-3 py-1.5 shadow-sm flex items-center justify-center text-center" data-id="element-146">
                <p className="text-xs font-semibold text-[#3E2B1F] whitespace-nowrap" data-id="element-147">
                  {stat}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}